import {
  notificationByIdQuery,
  notificationCreate,
  notificationUpdate,
} from '@/entities/notifications'
import type {
  CreateOrUpdateNotificationModel,
  NotificationModel,
} from '@/shared/api'
import { ROUTES } from '@/shared/config'
import { navigateToFx } from '@/shared/lib/providers'
import { createEvent, sample } from 'effector'
import { or } from 'patronum'

// Submit

export const $submittingNotification = or(
  notificationCreate.$pending,
  notificationUpdate.$pending,
)

export const notificationSubmitted =
  createEvent<CreateOrUpdateNotificationModel>()
sample({
  source: notificationByIdQuery.$data,
  clock: notificationSubmitted,
  filter: (notification: NotificationModel | null): notification is null =>
    notification === null,
  fn: (
    _,
    notificationSubmittedData,
  ): {
    data: CreateOrUpdateNotificationModel
  } => {
    return { data: notificationSubmittedData }
  },
  target: notificationCreate.start,
})

sample({
  source: notificationByIdQuery.$data,
  clock: notificationSubmitted,
  filter: (
    notification: NotificationModel | null,
  ): notification is NotificationModel =>
    notification !== null && typeof notification.id === 'string',
  fn: (notification, notificationSubmittedData) => {
    return {
      id: notification.id,
      data: notificationSubmittedData,
    }
  },
  target: notificationUpdate.start,
})

// OnSubmitted

sample({
  clock: [
    notificationCreate.finished.success,
    notificationUpdate.finished.success,
  ],
  fn: () => ({ to: ROUTES.SETTINGS.NOTIFICATIONS }),
  target: navigateToFx,
})
